<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-bell-outline
          </v-icon>
          テナントへのお知らせ
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForms.title"
                        background-color="white"
                        dense
                        hide-details="auto"
                        label="タイトル"
                        outlined
                        rounded
                        persistent-placeholder
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="searchForms.use_important"
                        label="重要のみを検索"
                        dense
                        hide-details="auto"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addButtonClickEvent"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;テナントへのお知らせの追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="notifications"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.title`]="{ item }">
                <span :title="item.title">{{ item.title | truncate(35) }}</span>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.expired_at`]="{ item }">
                {{ item.expired_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="info darken-2"
                  icon
                  @click="editButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="editButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="error darken-2"
                  @click="deleteButtonClickEvent(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="error"
                  @click="deleteButtonClickEvent(item)"
                >
                  削除する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import Confirm from '../../../components/Confirm'
export default {
  name: 'DriverNotificationIndex',
  components: {
    Confirm,
  },
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      targetId: null,
      enableNotificationDialog: false,
      searchForms: {
        title: null,
        use_important: false,
      },
      tableHeaders: [
        { value: 'notification_at', text: '日時' },
        { value: 'title', text: 'タイトル' },
        { value: 'display_end_at', text: '表示期限' },
        { text: '詳細', value: 'editable', align: 'end' },
      ],
      notifications: [],
    }
  },
  computed: {
    ...mapState('AdminNotification', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminNotification', [
      'hasResult'
    ]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForms.title = this.searchCondition.title
    this.searchForms.use_important = this.searchCondition.use_important
    this.page = this.pagination.current_page
    this.searchNotification()
  },
  methods: {
    ...mapActions('AdminNotification', {
      fetchNotifications: 'index',
      deleteNotification: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    addButtonClickEvent () {
      this.$router.push({ name: 'AdminNotificationNew' })
    },
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableNotificationDialog = true
    },
    closeNotificationDialog () {
      this.enableNotificationDialog = false;
    },
    notificationCallback (forms) {
      this.closeNotificationDialog()
    },
    searchButtonClickEvent () {
      this.page = 1
      this.searchNotification()
    },
    editButtonClickEvent (item) {
      this.$router.push({ name: 'AdminNotificationEdit', params: { id: item.id } })
    },
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteNotification({id: item.id }).then(() =>{
            this.searchNotification ()
          })
        }
      })
    },
    changePage () {
      this.searchNotification()
    },
    searchNotification () {
      let params = { 
        title: this.searchForms.title,
        use_important: this.searchForms.use_important,
        page: this.page,
      }
      this.fetchNotifications(params).then((content) => {
        this.notifications = content.notifications
        this.total_count = content.pagination.total_count
      })
    }
  }
}
</script>
